import {ChangeDetectionStrategy, Component, input, model, output} from '@angular/core';
import {ProductSummary} from '../../../../../api';
import {TableModule} from 'primeng/table';
import {TranslatePipe} from '@ngx-translate/core';
import {ElciaButton} from '../../../../components/buttons/button/button';

@Component({
  selector: 'elcia-product-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableModule, TranslatePipe, ElciaButton],
  templateUrl: './product-grid.html',
})
export class ProductGrid {
  products = input.required<ProductSummary[]>();
  selectedProducts = model<ProductSummary[]>([]);
  productSelected = output<ProductSummary>();
  onDelete = output<ProductSummary>();

  onRowSelect(product: ProductSummary): void {
    this.productSelected.emit(product);
  }

  delete(event: Event, product: ProductSummary): void {
    event.stopPropagation();
    this.onDelete.emit(product);
  }
}
